/** JSON evidence export (MERGE-PLAN §4.4) — machine-readable for GRC ingestion. */
import type { EvidencePack } from '../types';
import { dateStamp, downloadBlob, slugify } from './download';

export function evidenceToJson(pack: EvidencePack): string {
  return JSON.stringify(pack, null, 2);
}

export function downloadEvidenceJson(pack: EvidencePack): void {
  const name = `evidence-${slugify(pack.meta.tenantName)}-${dateStamp(pack.meta.collectedAt)}.json`;
  downloadBlob(name, 'application/json', evidenceToJson(pack));
}
